export enum WorkTypeDisplayMode {
    VIEW = "VIEW",
    EDIT = "EDIT",
    ASSOCIATION = "ASSOCIATION"
};
